/* eslint-disable no-restricted-syntax */
import routeNames from '@/fish/router/constants'

export default [
  {
    name: routeNames.QUERY_FISH,
    path: 'query/:coord',
    redirect: { name: routeNames.QUERY_FISH_OVERVIEW },
    component: () =>
      import(/* webpackPrefetch: true */ '@/fish/components/query/query-card'),
    children: [
      {
        name: routeNames.QUERY_FISH_OVERVIEW,
        path: 'overview',
        component: () =>
          import(
            /* webpackPrefetch: true */ '@/fish/components/query/query-overview-tab'
          ),
      },
      {
        name: routeNames.QUERY_FISH_WEATHER,
        path: 'weather',
        component: () => import('@/fish/components/query/query-weather'),
      },
    ],
  },
]
